import { getSessionSaga, reduceLoading, reduceOperation } from 'metrix-common3';
import { call, put, select } from 'redux-saga/effects';
import { reducePolicyHistory } from '../../actions/policy/reducePolicyHistory';
import { selectPolicy } from '../../selectors/policy/selectPolicy';

export function* queryPolicySaga(_action) {
    try {
        yield put(reduceLoading({ code: 'queryPolicy', value: true }));
        const session = yield getSessionSaga();
        const policy = yield select(selectPolicy());
        const response = yield call(fetch, '/api/policyTransaction/query', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json',
                Authorization: session.authenticationToken.token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ policyQuery: { policy: policy.policy.guid } }),
        });
        const result = yield call([response, 'json']);
        yield put(reduceOperation(result.operation));
        if (!result.operation.status) {
            yield put(reduceLoading({ code: 'queryPolicy', value: false }));
            return;
        }
        yield put(reducePolicyHistory(result.policyTransactions));
        yield put(reduceLoading({ code: 'queryPolicy', value: false }));
        return;
    } catch (error) {
        console.log('Error while calling Query Policy API - ', error);
        yield put(reduceLoading({ code: 'queryPolicy', value: false }));
        return;
    }
}
